import ConstructionReports from './ConstructionReports';
import DayPlanReport from './DayPlanReport';
import ProjectPlanActualReport from './ProjectPlanActualReport';

const ReportRoutes = [
  {
    path: '/reports/construction',
    element: <ConstructionReports />,
  },
  {
    path: '/reports/day-plan',
    element: <DayPlanReport />,
  },
  {
    path: '/reports/project-plan-actual',
    element: <ProjectPlanActualReport />,
  },
];

export default ReportRoutes;
